import { Injectable } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {DevicesService} from '../../../services/devices.service';
import {PreferenceService} from '../../../services/preference.service';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import {Observable, of} from 'rxjs';
import * as featureActions from '../../index';
import {catchError, concatMap, map, mergeMap, switchMap, withLatestFrom} from 'rxjs/operators';
import { DeviceUPSControlActions } from '../actions/device-ups-control.actions';
import { UpdateInfoModel } from '../../updateInfo/update-info.model';
import { updateInfoType } from '../../../shareModel';
import { TranslateService } from '@ngx-translate/core';


@Injectable()
export class DeviceUPSControlEffects {
  constructor(private actions$: Actions<DeviceUPSControlActions>,
              private deviceService: DevicesService,
              private preferenceService: PreferenceService,
              private store$: Store<fromStore.State>,
              private translateService: TranslateService) {}

  ReadDeviceUPSControl$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.DeviceUPSControlActionTypes.GetUPSControlStatus),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const params = { ...action.payload, otp: user.otp };
      return this.deviceService.ReadUPSControlStatus(params).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.UpsertUPSControlStatus(res.msg.body)];
          } else {
            return [new featureActions.GetUPSControlStatusFail()];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.GetUPSControlStatusFail()];
        })
      );
    })
  ));

  ExecuteUPSControl$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.DeviceUPSControlActionTypes.ExecuteUPSControl),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const params = { ...action.payload, otp: user.otp };
      return this.deviceService.ExecuteUPSControl(params).pipe(
        switchMap((res: any) => {
          if (res.Flag) {
            return [new featureActions.ExecuteUPSControlSuccess()];
          } else {
            return [new featureActions.ExecuteUPSControlFail()];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.ExecuteUPSControlFail()];
        })
      );
    })
  ));
}
